module.exports = __webpack_public_path__ + "static/media/reports.97937f3c.svg";